import { createApp } from "vue";
import { createPinia } from "pinia"; // ✅ Import Pinia
import App from "./App.vue";
import router from "./router"; // If using Vue Router

const app = createApp(App);
const pinia = createPinia(); // ✅ Create Pinia instance

app.use(pinia); // ✅ Register Pinia before using any store
app.use(router); // If using Vue Router, make sure to use it after Pinia
app.mount("#app");
